import { IconPropsType } from '..';

export const FireIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.36577 18C6.45697 15.7808 6.93697 14.5104 7.64257 13.312C8.11237 12.5031 8.44081 11.6201 8.61377 10.7008C8.61377 10.7008 9.22017 11.6192 8.97697 13.0528C10.049 11.6656 10.257 9.4544 10.097 8.608C12.5194 10.5776 13.5562 14.848 12.1594 18C19.577 13.1168 14.001 5.8096 13.0298 4.9872C13.3498 5.8096 13.4138 7.2032 12.761 7.88C11.6538 3 8.92097 2 8.92097 2C9.24097 4.5168 7.73697 7.2672 6.29697 9.3232C6.24577 8.32 6.19137 7.6288 5.73857 6.6672C5.63617 8.4912 4.43777 9.976 4.11297 11.8032C3.67777 14.2768 4.44577 16.08 7.36577 18Z" />
  </svg>
);
